import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { CircleNotch } from "@phosphor-icons/react";

// Pages accessibles par rôle (doit rester synchronisé avec Sidebar.jsx)
const ROLE_PAGES = {
  admin: ["/", "/mouvements", "/stock", "/commandes", "/peremptions", "/finances", "/fournisseurs", "/categories", "/inventaire", "/utilisateurs", "/parametres", "/super-admin"],
  assistant: ["/", "/mouvements", "/stock", "/inventaire"],
  viewer: ["/", "/stock", "/peremptions"],
};

export default function ProtectedRoute({ children, requiredRole }) {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[color:var(--bg)] flex items-center justify-center">
        <CircleNotch size={32} className="animate-spin text-[color:var(--brand)]" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Vérification du rôle si requiredRole est spécifié
  if (requiredRole && user?.role !== requiredRole) {
    return <Navigate to="/" replace />;
  }

  return children;
}

/**
 * Wrapper qui vérifie si l'utilisateur a accès à la page courante selon son rôle.
 * Redirige vers "/" si la page n'est pas dans sa liste autorisée.
 */
export function RoleGuard({ children }) {
  const { user } = useAuth();
  const role = user?.role || "assistant";
  const allowed = ROLE_PAGES[role] || ROLE_PAGES.assistant;
  const currentPath = window.location.pathname;

  // Super admin a accès à tout
  if (user?.is_super_admin) return children;

  if (!allowed.includes(currentPath)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
